import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { withStyles } from '@mui/styles';
import Radio from '@mui/material/Radio';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import NumberInput from 'components/inputs/NumberInput';

import DateTimeDeadline from './DateTimeDeadline';

import styles from './styles';

let timedId;

const DeadlineForm = observer(({
    classes, onDaysChange, onChangeDeadlineType, onChangeDeadlineDate, min,
    max, defaultDeadline, description, initDays, initType, initDate, dateLabel, disabled, errorText, minDate, daysSuffix = 'Days',
    ...props
}) => {
    const [daysCount, setDaysCount] = useState(initDays);
    const [expirationDate, setExpirationDate] = useState(initDate);
    const [showError, setShowError] = useState(false);
    const [deadlineType, setDeadlineType] = useState(null); // 'days', 'date' or null

    useEffect(() => {
        setDeadlineType(initType === undefined ? 'days' : initType);
    }, [initType]);

    const handleChangeDaysCount = (e) => {
        e.preventDefault();
        const newValue = +e.target.value;
        const isInvalid = newValue < min || newValue > max;

        if (daysCount !== newValue) setDaysCount(newValue);
        if (showError !== isInvalid) setShowError(isInvalid);

        if (!isInvalid) {
            clearTimeout(timedId);
            timedId = setTimeout(() => {
                onDaysChange(newValue);
            }, 300);
        }
    };

    const handleChangeDeadlineDate = (newDate, isExpired) => {
        setExpirationDate(newDate);
        if (!isExpired) {
            onChangeDeadlineDate(newDate, isExpired);
        }
    };

    const handleChangeDeadlineType = (e) => {
        const { value } = e.target;
        setDeadlineType(value);
        if (value === 'days') {
            setDaysCount(defaultDeadline);
        }
        onChangeDeadlineType(value, expirationDate);
    };

    return (
        <div>
            <RadioGroup
                row
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                value={deadlineType}
                onChange={handleChangeDeadlineType}
            >
                <FormControlLabel classes={{ label: classes.formControlLabel }} value="date" control={<Radio disabled={!deadlineType || disabled} />} label="Date and Time" />
                <FormControlLabel classes={{ label: classes.formControlLabel }} value="days" control={<Radio disabled={!deadlineType || disabled} />} label="No. of Days" />
            </RadioGroup>
            {deadlineType === 'date' ? <>
                <DateTimeDeadline
                    {...props}
                    expirationDate={expirationDate}
                    handleChangeDeadlineDate={handleChangeDeadlineDate}
                    dateLabel={dateLabel}
                    disabled={disabled}
                    minDate={minDate}
                />
                <p className="u-mrg--tx3">{description}</p>
            </> : <>
                <div className="u-mrg--tx2" style={{ minHeight: 100 }}>
                    {deadlineType === 'days'
                        ? <>
                            <div className="u-dsp--f u-ai--center">
                                <NumberInput
                                    name="timerCount"
                                    value={daysCount}
                                    onChange={handleChangeDaysCount}
                                    type="number"
                                    min={min}
                                    max={max}
                                    className="u-mrg--rx2"
                                    disabled={!deadlineType || disabled}
                                />
                                <Typography variant="h6">{daysSuffix}</Typography>
                            </div>
                            <p className="u-mrg--tx3">{description}</p>
                        </> : <span>No deadline</span>
                    }
                    {
                        showError && (
                            <p className={classes.errorStyle}>{errorText || 'Deadline must be greater than 0 days and less than 30 days'}</p>
                        )
                    }
                </div>
                </>
            }
        </div>
    );
});

export default withStyles(styles)(DeadlineForm);
